const JOB_LABELS = {
  name: 'Jobs',
  adbWorkspace: 'Workspace',
  status: 'Job Status',
  condition: 'Job Condition',
  dataAsset: '',
  silverTable: '',
  sourceTable: 'Source Table',
  targetTable: 'Target Table',
  adbGoldTable: 'Gold Table',
};
const PIPELINE_LABELS = {
  name: 'Pipelines',
  status: 'Pipeline Status',
  condition: 'Pipeline Condition',
  dataAsset : 'Data Asset', 
  silverTable: 'Silver Table',
}

export const PLATFORM_LABEL_MAP: Record<number, { name: string; status: string; condition: string; dataAsset: string; silverTable: string; adbWorkspace?: string; adbGoldTable?: string;}> = {
  4: PIPELINE_LABELS,
  1: JOB_LABELS,
  2: JOB_LABELS,
  3: JOB_LABELS,
  7: JOB_LABELS,
  8: JOB_LABELS,
  9: JOB_LABELS,
  10: JOB_LABELS,
  11: JOB_LABELS
  // ...add more as needed
};

export const PLATFORM_NAME_TO_ID: Record<string, number> = {
  'Teradata': 1,
  'BODS': 2,
  'DDH': 3,
  'ADF': 4,
  'MDT': 7,
  'Windows Server': 8,
  'SAP BW': 9,
  'SQL Server Agent (NewsPage)': 10,
  'ADB': 11,
  // ...add more as needed
};

export const PLATFORM_ID_TO_NAME: Record<number, string> = {
  1: 'Teradata',
  2: 'BODS',
  3: 'DDH',
  4: 'ADF',
  7: 'MDT',
  8: 'Windows Server',
  9: 'SAP BW',
  10: 'SQL Server Agent (NewsPage)',
  11: 'ADB',
  // ...add more as needed
};

export const FOLDER_NAME_TO_ALIAS: Record<string, string> = {
  SAPS4H_AME: 'S4',
  SAPENTHANA: 'EHANA',
};

export const PLATFORM_NAMES = {
  "TERADATA" : 1,
  "BODS" : 2,
  "DDH" : 3,
  "ADF" : 4,
  "MDT" : 7,
  "WINDOWS_SERVER" : 8,
  "SAP_BW" : 9,
  "SQL_AGENT_JOBS" : 10,
  "ADB" : 11,
  // ...add more as needed
};

export const DEFAULT_SCHEDULER_LABELS = JOB_LABELS;

export const DEFAULT_COLUMNS_PIPELINES_TABS = [
  'Platform',
  'ADF Name',
  PIPELINE_LABELS.name,
  'Parameters',
  'Trigger Name',
  'Schedule Info',
  'Scheduler',
  PIPELINE_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_WINDOWS_TABS = [
  'Platform',
  JOB_LABELS.name,
  'Task Name',
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_SAP_TABS = [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_SQL_TABS = [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_ADB_TABS = [
  'Platform',
  `${JOB_LABELS.adbWorkspace} Name`,
  JOB_LABELS.name,
  `${JOB_LABELS.adbGoldTable} Name`,
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_DDH_TABS= [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_MDT_TABS= [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_JOBS_TABS= [
  'Platform',
  JOB_LABELS.name,
  'Folder Name',
  'Subfolder Name',
  'Schedule Info',
  'Scheduler',
  JOB_LABELS.status,
  'Cyclic',
  'Actions'
];

export const DEFAULT_COLUMNS_PIPELINES_EXEC = [
  'Platform',
  'ADF Name',
  PIPELINE_LABELS.name,
  'Trigger Name',
  'Schedule Info',
  'Pipeline Run ID',
  PIPELINE_LABELS.status,
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const DEFAULT_COLUMNS_EXEC = [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  JOB_LABELS.status,
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const DEFAULT_COLUMNS_SQL_EXEC = [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  'Step ID',
  'Step Name',
  JOB_LABELS.status,
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const DEFAULT_COLUMNS_ADB_EXEC = [
  'Platform',
  `${JOB_LABELS.adbWorkspace} Name`,
  JOB_LABELS.name,
  JOB_LABELS.sourceTable,
  JOB_LABELS.targetTable,
  'JOB Run URL',
  'Schedule Info',
  JOB_LABELS.status,
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const DEFAULT_COLUMNS_JOBS_EXEC = [
  'Platform',
  JOB_LABELS.name,
  'Folder Name',
  'Subfolder Name',
  'Schedule Info',
  JOB_LABELS.status,
  'Order Date',
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const DEFAULT_COLUMNS_MDT_DDH_EXEC = [
  'Platform',
  JOB_LABELS.name,
  'Schedule Info',
  JOB_LABELS.status,
  'Order Date',
  'Act. Start Time (CST)',
  'Act. End Time (CST)',
  'Avg. Exec. Time',
  'Total Exec.',
  'Last 30 Execution Trend',
  'Comments'
];

export const PLATFORM_FILTER_DROPDOWN_RULES = [
  {
    platform: "ADF",
    platformId: 4,
    schedulerOptions: ["All", "ADF"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Instance Name": "1" },
      { "Pipeline Name": "N" },
      { "Data Asset Name": "N" },
      { "Silver Table Name": "N" }
    ]
  },
  {
    platform: "Windows Server",
    platformId: 8,
    schedulerOptions: ["Windows Task Scheduler"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
    ]
  },
  {
    platform: "SAP BW",
    platformId: 9,
    schedulerOptions: ["SAP BW"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
    ]
  },
  {
    platform: "SQL Server Agent (NewsPage)",
    platformId: 10,
    schedulerOptions: ["SQL Server"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
    ]
  },
  {
    platform: "DDH",
    platformId: 3,
    schedulerOptions: ["All", "NATIVE", "CUSTOM"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
    ]
  },
  {
    platform: "Teradata",
    platformId: 1,
    schedulerOptions: [ "AutoSys", "Control-M"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
      { "Folder Name": "N" },
    ]
  },
  {
    platform: "BODS",
    platformId: 2,
    schedulerOptions: ["Control-M-PGT"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
      { "Folder Name": "N" },
    ]
  },
  {
    platform: "MDT",
    platformId: 7,
    schedulerOptions: ["All", "MDT"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
    ]
  },
  {
    platform: "ADB",
    platformId: 11,
    schedulerOptions: ["ADB"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Workspace Name": "1" },
      { "Job Name": "N" },
      { "Gold Table Name": "N" },
    ]
  },
  {
    platform: "All",
    platformId: 0,
    schedulerOptions: ["All", "AutoSys", "Control-M", "Control-M-PGT", "NATIVE", "CUSTOM", "MDT"],
    dropdownList: [
      { "Scheduler Name": "1" },
      { "Job Name": "N" },
      { "Folder Name": "N" },
    ]
  },
  // Add more platforms as needed
];